import React, { useState, useEffect } from "react";
import { X } from "lucide-react";

const CAFE_ID = "e7b20008-f754-402a-944c-027bf11d68c0";

export default function ItemModal({
  isOpen,
  onClose,
  onSave,
  itemData,
  categoryId,
  loading
}) {
  const [form, setForm] = useState({
    name: "",
    price: "",
    gst: 0,
    tax_included: false,
    is_veg: true,
    is_available: true,
    image: null,
  });

  /* ================= SET FORM DATA ================= */

  useEffect(() => {
    if (itemData) {
      setForm({
        name: itemData.name || "",
        price: itemData.price || "",
        gst: itemData.gst || 0,
        tax_included: itemData.tax_included || false,
        is_veg: itemData.is_veg ?? true,
        is_available: itemData.is_available ?? true,
        image: null,
      });
    } else {
      setForm({
        name: "",
        price: "",
        gst: 0,
        tax_included: false,
        is_veg: true,
        is_available: true,
        image: null,
      });
    }
  }, [itemData]);

  if (!isOpen) return null;

  /* ================= SUBMIT ================= */

  const handleSubmit = () => {
    const data = new FormData();

    // ✅ Only send cafe_id during CREATE
    if (!itemData) {
      data.append("cafe_id", CAFE_ID);
    }

    data.append("category_id", categoryId);
    data.append("name", form.name);
    data.append("price", form.price);
    data.append("gst", form.gst);
    data.append("tax_included", form.tax_included);
    data.append("is_veg", form.is_veg);
    data.append("is_available", form.is_available);

    if (form.image) {
      data.append("image", form.image);
    }

    onSave(data, itemData?.id);
  };

  return (
    <div className="km-modal-overlay">
      <div className="km-modal-card">

        {/* CLOSE BUTTON */}
        <button className="km-modal-close" onClick={onClose}>
          <X size={18} />
        </button>

        {/* TITLE */}
        <h2 className="km-modal-title">
          {itemData ? "Edit Item" : "Add New Item"}
        </h2>

        {/* NAME */}
        <div className="km-form-group">
          <label>Name</label>
          <input
            value={form.name}
            onChange={e => setForm({ ...form, name: e.target.value })}
          />
        </div>

        {/* PRICE */}
        <div className="km-form-group">
          <label>Price</label>
          <input
            type="number"
            value={form.price}
            onChange={e => setForm({ ...form, price: e.target.value })}
          />
        </div>

        {/* GST */}
        <div className="km-form-group">
          <label>GST (%)</label>
          <input
            type="number"
            value={form.gst}
            onChange={e => setForm({ ...form, gst: e.target.value })}
          />
        </div>

        {/* IMAGE */}
        <div className="km-form-group">
          <label>Upload Image</label>
          <input
            type="file"
            onChange={e =>
              setForm({ ...form, image: e.target.files[0] })
            }
          />
        </div>

        {/* TOGGLES */}
        <div className="item-toggle-group">

          <div className="item-toggle-row">
            <span>Tax Included</span>
            <label className="item-switch">
              <input
                type="checkbox"
                checked={form.tax_included}
                onChange={e =>
                  setForm({ ...form, tax_included: e.target.checked })
                }
              />
              <span className="item-slider"></span>
            </label>
          </div>

          <div className="item-toggle-row">
            <span>Veg</span>
            <label className="item-switch">
              <input
                type="checkbox"
                checked={form.is_veg}
                onChange={e =>
                  setForm({ ...form, is_veg: e.target.checked })
                }
              />
              <span className="item-slider"></span>
            </label>
          </div>

          <div className="item-toggle-row">
            <span>Active</span>
            <label className="item-switch">
              <input
                type="checkbox"
                checked={form.is_available}
                onChange={e =>
                  setForm({ ...form, is_available: e.target.checked })
                }
              />
              <span className="item-slider"></span>
            </label>
          </div>

        </div>

        {/* SAVE BUTTON */}
        <button
          className="km-save-btn"
          onClick={handleSubmit}
          disabled={loading}
        >
          {loading
            ? "Saving..."
            : itemData
              ? "Update Item"
              : "Save Item"}
        </button>

      </div>
    </div>
  );
}